export enum PaymentTypesEnum {
    STRIPE = 'stripe',
    CASH = 'cash',
    TRANSFER = 'transfer',
    REFUND = 'refund',
    PAYMENT = 'payment',
}

export enum ReloadCreditTypesEnum {
    STRIPE = 'stripe',
    CASH = 'cash',
}

export enum WithdrawCreditTypesEnum {
    TRANSFER = 'transfer',
    REFUND = 'refund',
}

export enum TransactionTypeEnum {
    DEBIT = 'debit',
    CREDIT = 'credit',
    REFUND = 'refund',
    TRANSFER = 'transfer',
}

export enum PaymentCategoriesEnum {
    MEAL = 'meal',
    NURSERY = 'nursery',
    ACTIVITY = 'activity',
    HOMEWORK = 'homework',
    OTHER = 'other',
}

export enum PerdiodsEnum {
    TODAY = 'today',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
}

export enum WalletTabEnum {
    ALL = 'all',
    NURSERY = 'nursery',
    MEAL = 'meal',
    ACTIVITY = 'activity',
    HOMEWORK = 'homework',
}

export enum TransactionTypeEnumV2 {
    DEBIT = 'debit',
    CREDIT = 'credit',
}

export enum CreditTypeEnumV2 {
    CASH = 'cash',
    STRIPE = 'stripe',
    TRANSFER = 'transfer',
    REFOUND = 'refund', //=remboursement
    PAYMENT = 'payment', //=virement
    SCHOOL_CLASS_LOAD = 'school_class_load',
}

export enum DebitTypeEnumV2 {
    PAYMENT = 'payment',
    UNLOAD = 'unload',
    UNLOAD_CLASS = 'school_class_unload',
}

export enum TransactionPurposeEnum {
    NURSERY = 'Pointing',
    MEAL = 'BookMeal',
    ACTIVITY = 'Activity',
    HOMEWORK = 'BookHomework',
    USER = 'User', // va disparaitre
}
